export default __webpack_public_path__ + "static/media/scroll_down_logo.ac25b0c4.png";